export type PreferredWorkspaceSource = "server" | "local_fallback" | "none"

export interface ResolvedPreferredWorkspaceId {
  preferredWorkspaceId: string | null
  source: PreferredWorkspaceSource
}

/**
 * The server preference wins when present; localStorage covers the window
 * before the session resolves and the "no server preference yet" case. The id
 * is returned verbatim — whether it names a workspace the user can still reach
 * is the home-redirect's accessibility check, not this function's.
 */
export function resolvePreferredWorkspaceId({
  serverPreferredWorkspaceId,
  localPreferredWorkspaceId,
}: {
  serverPreferredWorkspaceId: string | null | undefined
  localPreferredWorkspaceId: string | null
}): ResolvedPreferredWorkspaceId {
  if (serverPreferredWorkspaceId != null) {
    return {
      preferredWorkspaceId: serverPreferredWorkspaceId,
      source: "server",
    }
  }
  if (localPreferredWorkspaceId != null) {
    return {
      preferredWorkspaceId: localPreferredWorkspaceId,
      source: "local_fallback",
    }
  }
  return { preferredWorkspaceId: null, source: "none" }
}
